import { useLocation, useNavigate } from 'react-router-dom';
import { useLiff } from '@/hooks/useLiff';
import { Button, Card, ErrorMessage } from '@/components/common';

interface ErrorState {
  title?: string;
  message?: string;
  canRetry?: boolean;
}

export const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const liff = useLiff();

  const state = location.state as ErrorState | null;

  const title = state?.title || 'エラーが発生しました';
  const message =
    state?.message ||
    '予期しないエラーが発生しました。しばらく経ってから再度お試しください。';
  const canRetry = state?.canRetry ?? true;

  const handleRetry = () => {
    navigate('/', { replace: true });
  };

  const handleClose = () => {
    liff.closeLiff();
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* ヘッダー */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">FLARO LINE連携</h1>
        </div>

        <Card>
          <ErrorMessage title={title} message={message}>
            <div className="flex gap-3 mt-4">
              {canRetry && (
                <Button variant="primary" size="sm" onClick={handleRetry}>
                  最初からやり直す
                </Button>
              )}
              <Button variant="secondary" size="sm" onClick={handleClose}>
                閉じる
              </Button>
            </div>
          </ErrorMessage>
        </Card>

        {/* サポート情報 */}
        <div className="mt-6 text-center text-sm text-gray-500">
          <p>問題が解決しない場合は、管理者にお問い合わせください。</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
